module.exports = __webpack_public_path__ + "static/img/scene-zntc.8c79863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene-zntc.png
// module id = u6h4
// module chunks = 1